<template>
  <div id="resetPassword">
    <v-container class="pa-0" v-if="preUrl">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left :to="preUrl ? this.$route.params.preUrl : `/admin/families`" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="passwordForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4"> 
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap row>
            <v-flex xs12 sm8 md6>
              <v-select v-if="!preUrl" @change="changedData" :rules="[rules.required]" v-model="userType" :items="userList" label="Selete User Type" class="requiredfield pr-4 pl-4" required></v-select>
              <v-select v-if="preUrl" disabled :value="user.value" :label="user.label" class="pr-4 pl-4"></v-select>
            </v-flex>
        </v-layout>
        <v-layout wrap row>
            <v-flex xs12 sm8 md6 v-if="!preUrl">
                <v-autocomplete
                v-if="userType === 'Family'"
                v-model="userId"
                browser-autocomplete="new-username"
                @change="changedData"
                @keyup.enter="searchFamilies($event)"
                :items="recipientList"
                item-text="name"
                item-value="id"
                label="Family"
                :rules="[rules.toRule]"
                hide-no-data
                placeholder="Search by Name / Nickname / PPN"
                hint="Type atleast 3 characters to search"
                id="recipientSearch"
                class="required pr-4 pl-4">
                <v-icon slot="append" @click="searchFamilies($event)"> search </v-icon>
              </v-autocomplete>
               <v-autocomplete
                  v-else
                  label="Agency Username" 
                  class="required pr-4 pl-4"
                  item-text="name"
                  :item-value="'human[0].user'"
                  :items="AgencyList.filter(x => x.human && x.human[0] && x.human[0].user)"
                  :rules="rulesAgency"
                  v-model="userId"
                  @change="changedData">
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout wrap row>
              <v-flex xs12 sm8 md6>
              <v-text-field ref="password"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="enterPasswordRules"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                @input="changedData"
                class="input-group--focused requiredfield pr-4 pl-4 pb-4"
                hint="At least 8 characters"
                label="Enter New Password"
                v-model="newPassword"
                browser-autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right ">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session config store */
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { checkWPToken, requestToWPPF, getCollection, request } from '../../helpers/helpers';
import swal from 'sweetalert2';
export default {
  name: 'reset-password',
  data: () => ({
    config: config,
    newPassword: '',
    userId: '',
    preUrl: false,
    user: {
      value: '',
      label: ''
    },
    recipientList: [],
    searchFamilyList: [],
    query: {
      family: ''
    },
    userType: 'Family',
    userList: [
      'Family',
      'Agency'
    ],
    show1: false,
    rules: {
      required: value => !!value || 'Field is required.',
      toRule: (v) => !!v || 'Please select user',
    },
    rulesAgency: [
      v => !!v || 'Agency is required'
    ],
    selectedData: false,
  }),
  computed: {
    ...mapGetters(['Account', 'Agency']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    enterPasswordRules () {
      return [
        v => !!v || 'Field is required.',
        v => !!v && v.length >= 8 || 'Password cannot be less than 8 characters',
        v => /(?=.*?[A-Z])/.test(v) || 'Password must have upper case letter',
        v => /(?=.*?[0-9])/.test(v) || 'Password must have one number'
      ];
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.initialize();
    this.getUser();
  },
  methods: {
    getUser () {
      console.log('this.$route.params.item', this.$route.params.item);
      if (this.$route.params.preUrl && ['/admin/families', '/admin/agencies'].indexOf(this.$route.params.preUrl) > -1) {
        this.user.value = this.$route.params.item.mapping_id;
        this.user.label = this.$route.params.item.username;
        this.mapId = this.$route.params.item.mapping_id;
        this.preUrl = true;
      }
    },
    async searchFamilies (e) {
      this.recipientList = [];
      this.familyResult = [];
      this.searchFamilyList = [];
      this.query.family = e.target.value ? e.target.value : document.querySelector('input[id="recipientSearch"]').value;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if (this.query.family && this.query.family.length > 2) {
        let where = { };
        if (this.query.family && this.query.family.length) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        if (this.query.status) {
          where.profile_status = this.query.status;
        }
        let populate = [{ 'path': 'human', populate: { path: 'user', select: 'username' }}, 'contactInfo.country', 'contactInfo.state'];
        let { error, data } = await getCollection('Account', true, 0, populate, where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.searchFamilyList = data;
            this.recipientList = data;
            this.familyFilter();
          }
        }
      }
    },
    async familyFilter () {
      if (this.query.family && this.query.family.length > 2) {
        if (this.recipientList.length) {
          this.recipientList.filter(x => x.human && x.human[0] && x.human[0].user && x.human[0].user.id).forEach(item => {
            let obj = {};
            if (item.nickname.toLowerCase().includes(document.querySelector('input[id="recipientSearch"]').value.toLowerCase())) {
              obj = {
                name: item.nickname,
                id: item.human[0].user.id
              };
            } else {
              let text = '';
              if (item.ppn === document.querySelector('input[id="recipientSearch"]').value) {
                text = `${item.ppn} / ${item.name}`;
              } else {
                text = item.name;
              }
              obj = {
                name: text,
                id: item.human[0].user.id
              };
            }
            this.familyResult.push(obj);
          });
        }
        this.recipientList = [...this.familyResult];
      }
    },
    // @vuese
    // Used to initialize the agency list if not exists.
    async initialize () {
      if (!this.AgencyList.length) {
        let where = { _id: { $ne: this.Agency.id }, is_admin: false };
        let attributes = 'name,nickname,email,createdAt,_id,mapping_id,map_sub_id';
        let populate = [{ path: 'human', select: '_id user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    async save () {
      if (this.$refs.passwordForm.validate()) {
        let passwordUrl = 'User/Password/Update';
        const payload = {
          is_admin: true,
          user: this.preUrl ? this.$route.params.item.user_id : this.userId,
          new_password: this.newPassword
        };
        let response = await request(passwordUrl, 'POST', payload);
        if (response.error) {
          swal.fire({
            type: 'warning',
            title: '<b>Error</b>',
            html: response.error,
            showConfirmButton: false,
            timer: 2500
          });
        } else {
          swal.fire({
            type: 'success',
            title: 'The password was updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: async () => {
              if (this.preUrl) {
                this.$router.push({ path: this.$route.params.preUrl });
              } else {
                this.$refs.passwordForm.reset();
                this.selectedData = false;
              }
            }
          });
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      if (this.preUrl) {
        this.$router.push({ path: this.$route.params.preUrl });
      } else {
        this.$refs.passwordForm.reset();
        this.selectedData = false;
      }
    },

  }
};
</script>


<style lang="css" scoped>
  .requiredfield >>> label::before {
    content: "*";
    color: red;
    padding-right:3px;
  }
  .button-container{
    min-height:60px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword/ResetPassword.vue